import * as ko from 'knockout'
import template from './dog.starter.tpl.html'
import { DogStarterViewModel, Params } from './DogStarterViewModel'

if (!ko.components.isRegistered('dog-starter')) {
  ko.components.register('dog-starter', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new DogStarterViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
